<template>
 <div class="config-form">
	<el-dialog :visible.sync="dialogConfigVisible" :before-close="close" :close-on-click-modal="false">
		<template slot="title">
			<p v-html="dialogTitle" style="font-size:20px;display:inline-block;margin:0"></p>
		</template>
		<!-- <template v-if="config.params"> -->
			<p>{{' 计算模型：'+this.formatConfigType(currentConfig.type) +'  适用性别：'+this.formatConfigSex(currentConfig.gender)+'  位点数：'+currentConfig.sitesCount}}</p>
			<config-params-table :configId="currentConfig ? currentConfig.id : ''" :configType="currentConfig ? currentConfig.type :
      ''" v-loading="loading" ref="table"></config-params-table>
		<!-- </template> -->
		<!-- <template v-else>
			<p>暂无数据</p>
		</template> -->
	</el-dialog>
 </div>
</template>

<script>
import { formatConfigType, formatConfigSex } from 'enumeration/lab-order.js'
import configParamsTable from './config-params-table'
export default {
  name: 'detection-config-dialog',
  props: {
    dialogConfigVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      currentConfig: this.config
    }
  },
  components: {
    configParamsTable
  },
  computed: {

  },
  watch: {
    config (val) {
      this.currentConfig = val
    }
  },
  methods: {
    formatConfigType,
    formatConfigSex,
    close () {
      this.$refs.table.reset()
      this.$emit('update', false)
    }

  }
}
</script>

<style lang="less">
.config-form{
	.el-dialog{
		width:85%;
	}
	.el-dialog__body{
	padding:0 20px 30px;
	}
}
</style>
